export default __webpack_public_path__ + "static/media/company-logo1.d58b83c8.png";